import { computed } from "mobx";
import { inject, observer } from "mobx-react";
import moment from "moment";
import { useState, useEffect } from "react";

import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";

import "./style.scss";

const CompaniesCreate = inject("mainStore")(
    observer(({ mainStore }) => {
        const detailData = computed(() => mainStore.getMainStore("detailData")).get();
        const [step, setStep] = useState(1);

        useEffect(() => {
            detailData.offerDetail = { smsProviderType: "smsMts" };
            detailData.offerType = "bucket";
            detailData.dateStartCampaign = moment(new Date()).toISOString();
        }, []);

        const { offerTypeCPC = false, ghostOffer = false } = detailData;
        let wrap = [Step1, Step2, Step3, Step4, Step5, Step6];

        if (ghostOffer) {
            wrap = [Step1, Step2, Step3, Step4, Step6];
        }

        const countOfSteps = wrap.length || 5;
        const currentStep = step - 1;
        const Specified = wrap[currentStep] ? wrap[currentStep] : Step1;

        return <Specified setStep={setStep} step={step} countOfSteps={countOfSteps} />;
    }),
);

export default CompaniesCreate;
